import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IDegree } from "../../utils/types/models";

export default createEntityReducer<IDegree>(Endpoint.Degrees, Endpoint.DegreesList);
